import React from 'react';
import PropTypes from 'prop-types';
import AcademyConfigProp from './propTypes/academyConfig';

export default function Description({ academyConfig }) {
  const { smallHeadImage, subtitle, teachMethods = [] } = academyConfig || {};

  return (
    <div className="landing-description-and-selling">
      <div className="landing-description">
        <h2 className="description-title">{subtitle}</h2>
        <hr className="divider-white" />
      </div>
      <div className="row">
        <div className="col-md-7">
          <div className="selling-points row">
            {teachMethods.map(card => (
              <div
                key={card.title}
                className="academy-row-item col-12 col-lg-4 col-md-4"
              >
                <div className="selling-point">
                  <img
                    className="selling-point-image"
                    alt={card.title}
                    src={card.image}
                  />
                  <h4 className="selling-point-title">{card.title}</h4>
                  <p className="selling-point-description">
                    {card.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        {smallHeadImage && (
          <div className="col-md-5">
            <img
              alt="teaching methods"
              className="image-description-right"
              src={smallHeadImage}
            />
          </div>
        )}
      </div>
    </div>
  );
}

Description.propTypes = {
  academyConfig: PropTypes.shape(AcademyConfigProp.propType).isRequired,
};
